import React, { useEffect, useState } from "react";
import { ASSETS_URL, POCKET_BASE_URL } from "../../utils/config";

const AnniversaryCard = ({ anniversaryList }: { anniversaryList: any[] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // ⏳ Auto-change every 3 seconds
  useEffect(() => {
    if (!anniversaryList || anniversaryList.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % anniversaryList.length);
    }, 6000); // 3 seconds

    return () => clearInterval(interval);
  }, [anniversaryList]);

  // if (!anniversaryList || anniversaryList.length === 0) {
  //   return (
  //     <div className="flex justify-center items-center w-full sm:w-[40%] h-full text-gray-500">
  //       No anniversaries today 🎉
  //     </div>
  //   );
  // }

  const user = anniversaryList[currentIndex];

  return (
    <div className="flex sm:justify-center w-full sm:w-[40%] h-full">
      {/* Fixed size card */}
      <div
        className="w-full h-[500px] rounded-xl overflow-hidden relative transition-all duration-500 ease-in-out"
        style={{
          backgroundImage: "url(assets/birth.svg)",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Card content */}
        <div className="relative px-6 pt-14 sm:pt-16 pb-8 text-center flex flex-col justify-center h-full">
          {/* Heading */}
          <h1 className="sm:text-2xl text-xl font-bold text-red-600 mb-2 text-center items-center line-clamp-2 mt-2">
            Happy Work <br />
            Anniversary!
          </h1>

          {/* Profile image */}
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 sm:w-28 sm:h-28 rounded-full overflow-hidden">
              <img
                src={
                  user?.profilePic
                    ? `${ASSETS_URL}${user.profilePic}`
                    : user?.userId
                      ? `${POCKET_BASE_URL}${user.userId}`
                      : user?.name
                        ? "assets/user-4.svg"
                        : "assets/highlight.png"
                }
                alt={user?.name}
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).src = "assets/user-4.svg";
                }}
              />
            </div>
          </div>

          {/* Name */}
          <h2 className="text-base font-semibold text-gray-900">
            {user?.name}
          </h2>

          {/* Location / Department */}
          <p className="text-sm text-gray-700">
            {user?.department ? `${user?.department}, ` : ""}
            {user?.country || ""}
          </p>

          {/* Message */}
          <p className="text-gray-600 text-sm leading-relaxed pb-4 text-balanced mt-2">
            Wishing you continued success and <br /> happiness at work!
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnniversaryCard;
